var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmalyetSuite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33333 5.41667H12.5V3.75H8.33333V5.41667ZM8.33333 11.25H12.5V9.58333H8.33333V11.25ZM13.3333 15H1.66667C0.75 15 0 14.25 0 13.3333V1.66667C0 0.75 0.75 0 1.66667 0H13.3333C14.25 0 15 0.75 15 1.66667V13.3333C15 14.25 14.25 15 13.3333 15ZM2.5 6.66667H6.66667V2.5H2.5V6.66667ZM3.33333 3.33333H5.83333V5.83333H3.33333V3.33333ZM2.5 12.5H6.66667V8.33333H2.5V12.5ZM3.33333 9.16667H5.83333V11.6667H3.33333V9.16667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmalyetSuite);
export default __webpack_public_path__ + "static/media/amalyet-suite.00820f07d6dbc9d4c365c9eb6ff576f5.svg";
export { ForwardRef as ReactComponent };